// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.navbar-custom {
  display: flex;
  justify-content: space-between; 
  align-items: center;
}

.navbar-custom .nav {
  flex: 1 1;
  display: flex; 
}

.navbar-custom .nav .nav-item {
  margin-right: 10px; 
}

.navbar-custom .plant-select {
  display: flex;
  align-items: center;
  gap: 10px; 
  margin-left: auto;
}

.nav-item {
  display: flex;
  align-items: center;
  font-size: 16px;
}

.form-control {
  margin-left: 10px; 
  font-size: 16px;
}
#basic-nav-dropdown{
  font-size:16px;
  
}
.mr-auto{
  gap:1px;
}
.icon-style {
  width: 20%;
}

.user-icon-style {
  font-size: 30px;
}
.user-icon{
font-size: 16px;
}
.key-icon{
font-size: 16px;
}
.nav-list{
font-size: 16px;
}




@media only screen and (min-width: 1403px) {

.navbar-custom .nav .nav-item {
margin-right: 10px; 
}

.navbar-custom .plant-select {
display: flex;
align-items: center;
gap: 13px; 
margin-left: auto;
}

#basic-nav-dropdown{
    font-size:18px;
  }
  .nav-list{
    font-size: 18px;
  }


  .nav-item {
    display: flex;
    align-items: center;
    font-size: 18px;
  }
  .icon-style {
    width: 21%;
}

.user-icon-style {
    font-size: 32px;
}
 
  .user-icon{
    font-size: 17px;
  }
  .key-icon{
    font-size: 17px;
  }
  .form-control {
    margin-left: 10px; 
    font-size: 17px;
  }
}

@media only screen and (min-width: 1540px) {
.navbar-custom .nav .nav-item {
  margin-right: 11px; 
}

.navbar-custom .plant-select {
  display: flex;
  align-items: center;
  gap: 16px; 
  margin-left: auto;
}

 #basic-nav-dropdown{
      font-size:20px;
    }
 .nav-list{
      font-size: 20px;
    }
    .nav-item {
      display: flex;
      align-items: center;
      font-size: 20px;
    }
    .icon-style {
      width: 23%;
  }
  
  .user-icon-style {
      font-size: 34px;
  }
   
    .user-icon{
      font-size: 19px;
    }
    .key-icon{
      font-size: 19px;
    }
    .form-control {
      margin-left: 10px; 
      font-size: 20px;
    }
}

@media only screen and (min-width: 1684px) {
.navbar-custom .nav .nav-item {
  margin-right: 12px; 
}

.navbar-custom .plant-select {
  display: flex;
  align-items: center;
  gap: 19px;
  margin-left: auto;
}

 #basic-nav-dropdown{
      font-size:21px;
    }
    .nav-list{
      font-size: 21px;
    }
    .mr-auto{
      gap:2px;
    }
    .nav-item {
      display: flex;
      align-items: center;
      font-size: 21px;
    }
    .icon-style {
      width: 25%;
  }
  
  .user-icon-style {
      font-size: 36px;
  }
   
    .user-icon{
      font-size: 20px;
    }
    .key-icon{
      font-size: 20px;
    }
    .form-control {
      margin-left: 10px; 
      font-size: 21px;
    }
}



@media only screen and (min-width: 1874px) {
.navbar-custom .nav .nav-item {
  margin-right: 13px; 
}

.navbar-custom .plant-select {
  display: flex;
  align-items: center;
  gap: 19px;
  margin-left: auto;
}

 #basic-nav-dropdown{
      font-size:24px;
    }

    .nav-list{
      font-size: 24px;
    }
    .mr-auto{
      gap:3px;
    }
    .nav-item {
      display: flex;
      align-items: center;
      font-size: 24px;
    }
    .icon-style {
      width: 29%;
  }
  
  .user-icon-style {
      font-size: 43px;
  }
   
    .user-icon{
      font-size: 22px;
    }
    .key-icon{
      font-size: 22px;
    }
    .form-control {
      margin-left: 10px; 
      font-size: 23px;
    }
}


@media only screen and (min-width: 2530px) {
.navbar-custom .nav .nav-item {
  margin-right: 14px; 
}

.navbar-custom .plant-select {
  display: flex;
  align-items: center;
  gap: 23px;
  margin-left: auto;
}

 #basic-nav-dropdown{
      font-size:32px;
    }
    .nav-list{
      font-size: 31px;
    }
    .mr-auto{
      gap:8px;
    }
    .nav-item {
      display: flex;
      align-items: center;
      font-size: 32px;
    }
    .icon-style {
      width: 38%;
  }
  
  .user-icon-style {
      font-size: 52px;
  }
   
    .user-icon{
      font-size: 29px;
    }
    .key-icon{
      font-size: 29px;
    }
    .form-control {
      margin-left: 10px; 
      font-size: 32px;
    }
}

@media only screen and (min-width: 3796px) {
.navbar-custom .nav .nav-item {
  margin-right: 16px; 
}

.navbar-custom .plant-select {
  display: flex;
  align-items: center;
  gap: 44px;
  margin-left: auto;
}

 #basic-nav-dropdown{
      font-size:48px;
    }
    .nav-list{
      font-size: 46px;
    }
    .mr-auto{
      gap:30px;
    }
    .nav-item {
      display: flex;
      align-items: center;
      font-size: 46px;
    }
    .icon-style {
      width: 52%;
  }
  
  .user-icon-style {
      font-size: 80px;
  }
   
    .user-icon{
      font-size:40px;
    }
    .key-icon{
      font-size: 40px;
    }
    .form-control {
      margin-left: 10px; 
      font-size: 45px;
    }
}

@media only screen and (min-width: 5061px) {
.navbar-custom .nav .nav-item {
  margin-right: 18px; 
}

.navbar-custom .plant-select {
  display: flex;
  align-items: center;
  gap: 50px;
  margin-left: auto;
}

 #basic-nav-dropdown{
      font-size:65px;
    }
    .nav-list{
      font-size: 63px;
    }
    .mr-auto{
      gap:35px;
    }
    .nav-item {
      display: flex;
      align-items: center;
      font-size: 65px;
    }
    .icon-style {
      width: 63%;
  }
  
  .user-icon-style {
      font-size: 98px;
  }
   
    .user-icon{
      font-size:55px;
    }
    .key-icon{
      font-size: 55px;
    }
    .form-control {
      margin-left: 10px; 
      font-size: 60px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Header.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,cAAc;;AAEhB;AACA;EACE,OAAO;AACT;AACA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;AACA;AACA,eAAe;AACf;AACA;AACA,eAAe;AACf;AACA;AACA,eAAe;AACf;;;;;AAKA;;AAEA;AACA,kBAAkB;AAClB;;AAEA;AACA,aAAa;AACb,mBAAmB;AACnB,SAAS;AACT,iBAAiB;AACjB;;AAEA;IACI,cAAc;EAChB;EACA;IACE,eAAe;EACjB;;;EAGA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;EAEE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;CAEC;MACK,cAAc;IAChB;CACH;MACK,eAAe;IACjB;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,eAAe;IACjB;IACA;MACE,UAAU;EACd;;EAEA;MACI,eAAe;EACnB;;IAEE;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,iBAAiB;MACjB,eAAe;IACjB;AACJ;;AAEA;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;CAEC;MACK,cAAc;IAChB;IACA;MACE,eAAe;IACjB;IACA;MACE,OAAO;IACT;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,eAAe;IACjB;IACA;MACE,UAAU;EACd;;EAEA;MACI,eAAe;EACnB;;IAEE;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,iBAAiB;MACjB,eAAe;IACjB;AACJ;;;;AAIA;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;CAEC;MACK,cAAc;IAChB;;IAEA;MACE,eAAe;IACjB;IACA;MACE,OAAO;IACT;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,eAAe;IACjB;IACA;MACE,UAAU;EACd;;EAEA;MACI,eAAe;EACnB;;IAEE;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,iBAAiB;MACjB,eAAe;IACjB;AACJ;;;AAGA;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;CAEC;MACK,cAAc;IAChB;IACA;MACE,eAAe;IACjB;IACA;MACE,OAAO;IACT;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,eAAe;IACjB;IACA;MACE,UAAU;EACd;;EAEA;MACI,eAAe;EACnB;;IAEE;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,iBAAiB;MACjB,eAAe;IACjB;AACJ;;AAEA;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;CAEC;MACK,cAAc;IAChB;IACA;MACE,eAAe;IACjB;IACA;MACE,QAAQ;IACV;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,eAAe;IACjB;IACA;MACE,UAAU;EACd;;EAEA;MACI,eAAe;EACnB;;IAEE;MACE,cAAc;IAChB;IACA;MACE,eAAe;IACjB;IACA;MACE,iBAAiB;MACjB,eAAe;IACjB;AACJ;;AAEA;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;CAEC;MACK,cAAc;IAChB;IACA;MACE,eAAe;IACjB;IACA;MACE,QAAQ;IACV;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,eAAe;IACjB;IACA;MACE,UAAU;EACd;;EAEA;MACI,eAAe;EACnB;;IAEE;MACE,cAAc;IAChB;IACA;MACE,eAAe;IACjB;IACA;MACE,iBAAiB;MACjB,eAAe;IACjB;AACJ","sourcesContent":["\r\n.navbar-custom {\r\n  display: flex;\r\n  justify-content: space-between; \r\n  align-items: center;\r\n}\r\n\r\n.navbar-custom .nav {\r\n  flex: 1;\r\n  display: flex; \r\n}\r\n\r\n.navbar-custom .nav .nav-item {\r\n  margin-right: 10px; \r\n}\r\n\r\n.navbar-custom .plant-select {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px; \r\n  margin-left: auto;\r\n}\r\n\r\n.nav-item {\r\n  display: flex;\r\n  align-items: center;\r\n  font-size: 16px;\r\n}\r\n\r\n.form-control {\r\n  margin-left: 10px; \r\n  font-size: 16px;\r\n}\r\n#basic-nav-dropdown{\r\n  font-size:16px;\r\n  \r\n}\r\n.mr-auto{\r\n  gap:1px;\r\n}\r\n.icon-style {\r\n  width: 20%;\r\n}\r\n\r\n.user-icon-style {\r\n  font-size: 30px;\r\n}\r\n.user-icon{\r\nfont-size: 16px;\r\n}\r\n.key-icon{\r\nfont-size: 16px;\r\n}\r\n.nav-list{\r\nfont-size: 16px;\r\n}\r\n\r\n\r\n\r\n\r\n@media only screen and (min-width: 1403px) {\r\n\r\n.navbar-custom .nav .nav-item {\r\nmargin-right: 10px; \r\n}\r\n\r\n.navbar-custom .plant-select {\r\ndisplay: flex;\r\nalign-items: center;\r\ngap: 13px; \r\nmargin-left: auto;\r\n}\r\n\r\n#basic-nav-dropdown{\r\n    font-size:18px;\r\n  }\r\n  .nav-list{\r\n    font-size: 18px;\r\n  }\r\n\r\n\r\n  .nav-item {\r\n    display: flex;\r\n    align-items: center;\r\n    font-size: 18px;\r\n  }\r\n  .icon-style {\r\n    width: 21%;\r\n}\r\n\r\n.user-icon-style {\r\n    font-size: 32px;\r\n}\r\n \r\n  .user-icon{\r\n    font-size: 17px;\r\n  }\r\n  .key-icon{\r\n    font-size: 17px;\r\n  }\r\n  .form-control {\r\n    margin-left: 10px; \r\n    font-size: 17px;\r\n  }\r\n}\r\n\r\n@media only screen and (min-width: 1540px) {\r\n.navbar-custom .nav .nav-item {\r\n  margin-right: 11px; \r\n}\r\n\r\n.navbar-custom .plant-select {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px; \r\n  margin-left: auto;\r\n}\r\n\r\n #basic-nav-dropdown{\r\n      font-size:20px;\r\n    }\r\n .nav-list{\r\n      font-size: 20px;\r\n    }\r\n    .nav-item {\r\n      display: flex;\r\n      align-items: center;\r\n      font-size: 20px;\r\n    }\r\n    .icon-style {\r\n      width: 23%;\r\n  }\r\n  \r\n  .user-icon-style {\r\n      font-size: 34px;\r\n  }\r\n   \r\n    .user-icon{\r\n      font-size: 19px;\r\n    }\r\n    .key-icon{\r\n      font-size: 19px;\r\n    }\r\n    .form-control {\r\n      margin-left: 10px; \r\n      font-size: 20px;\r\n    }\r\n}\r\n\r\n@media only screen and (min-width: 1684px) {\r\n.navbar-custom .nav .nav-item {\r\n  margin-right: 12px; \r\n}\r\n\r\n.navbar-custom .plant-select {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 19px;\r\n  margin-left: auto;\r\n}\r\n\r\n #basic-nav-dropdown{\r\n      font-size:21px;\r\n    }\r\n    .nav-list{\r\n      font-size: 21px;\r\n    }\r\n    .mr-auto{\r\n      gap:2px;\r\n    }\r\n    .nav-item {\r\n      display: flex;\r\n      align-items: center;\r\n      font-size: 21px;\r\n    }\r\n    .icon-style {\r\n      width: 25%;\r\n  }\r\n  \r\n  .user-icon-style {\r\n      font-size: 36px;\r\n  }\r\n   \r\n    .user-icon{\r\n      font-size: 20px;\r\n    }\r\n    .key-icon{\r\n      font-size: 20px;\r\n    }\r\n    .form-control {\r\n      margin-left: 10px; \r\n      font-size: 21px;\r\n    }\r\n}\r\n\r\n\r\n\r\n@media only screen and (min-width: 1874px) {\r\n.navbar-custom .nav .nav-item {\r\n  margin-right: 13px; \r\n}\r\n\r\n.navbar-custom .plant-select {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 19px;\r\n  margin-left: auto;\r\n}\r\n\r\n #basic-nav-dropdown{\r\n      font-size:24px;\r\n    }\r\n\r\n    .nav-list{\r\n      font-size: 24px;\r\n    }\r\n    .mr-auto{\r\n      gap:3px;\r\n    }\r\n    .nav-item {\r\n      display: flex;\r\n      align-items: center;\r\n      font-size: 24px;\r\n    }\r\n    .icon-style {\r\n      width: 29%;\r\n  }\r\n  \r\n  .user-icon-style {\r\n      font-size: 43px;\r\n  }\r\n   \r\n    .user-icon{\r\n      font-size: 22px;\r\n    }\r\n    .key-icon{\r\n      font-size: 22px;\r\n    }\r\n    .form-control {\r\n      margin-left: 10px; \r\n      font-size: 23px;\r\n    }\r\n}\r\n\r\n\r\n@media only screen and (min-width: 2530px) {\r\n.navbar-custom .nav .nav-item {\r\n  margin-right: 14px; \r\n}\r\n\r\n.navbar-custom .plant-select {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 23px;\r\n  margin-left: auto;\r\n}\r\n\r\n #basic-nav-dropdown{\r\n      font-size:32px;\r\n    }\r\n    .nav-list{\r\n      font-size: 31px;\r\n    }\r\n    .mr-auto{\r\n      gap:8px;\r\n    }\r\n    .nav-item {\r\n      display: flex;\r\n      align-items: center;\r\n      font-size: 32px;\r\n    }\r\n    .icon-style {\r\n      width: 38%;\r\n  }\r\n  \r\n  .user-icon-style {\r\n      font-size: 52px;\r\n  }\r\n   \r\n    .user-icon{\r\n      font-size: 29px;\r\n    }\r\n    .key-icon{\r\n      font-size: 29px;\r\n    }\r\n    .form-control {\r\n      margin-left: 10px; \r\n      font-size: 32px;\r\n    }\r\n}\r\n\r\n@media only screen and (min-width: 3796px) {\r\n.navbar-custom .nav .nav-item {\r\n  margin-right: 16px; \r\n}\r\n\r\n.navbar-custom .plant-select {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 44px;\r\n  margin-left: auto;\r\n}\r\n\r\n #basic-nav-dropdown{\r\n      font-size:48px;\r\n    }\r\n    .nav-list{\r\n      font-size: 46px;\r\n    }\r\n    .mr-auto{\r\n      gap:30px;\r\n    }\r\n    .nav-item {\r\n      display: flex;\r\n      align-items: center;\r\n      font-size: 46px;\r\n    }\r\n    .icon-style {\r\n      width: 52%;\r\n  }\r\n  \r\n  .user-icon-style {\r\n      font-size: 80px;\r\n  }\r\n   \r\n    .user-icon{\r\n      font-size:40px;\r\n    }\r\n    .key-icon{\r\n      font-size: 40px;\r\n    }\r\n    .form-control {\r\n      margin-left: 10px; \r\n      font-size: 45px;\r\n    }\r\n}\r\n\r\n@media only screen and (min-width: 5061px) {\r\n.navbar-custom .nav .nav-item {\r\n  margin-right: 18px; \r\n}\r\n\r\n.navbar-custom .plant-select {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 50px;\r\n  margin-left: auto;\r\n}\r\n\r\n #basic-nav-dropdown{\r\n      font-size:65px;\r\n    }\r\n    .nav-list{\r\n      font-size: 63px;\r\n    }\r\n    .mr-auto{\r\n      gap:35px;\r\n    }\r\n    .nav-item {\r\n      display: flex;\r\n      align-items: center;\r\n      font-size: 65px;\r\n    }\r\n    .icon-style {\r\n      width: 63%;\r\n  }\r\n  \r\n  .user-icon-style {\r\n      font-size: 98px;\r\n  }\r\n   \r\n    .user-icon{\r\n      font-size:55px;\r\n    }\r\n    .key-icon{\r\n      font-size: 55px;\r\n    }\r\n    .form-control {\r\n      margin-left: 10px; \r\n      font-size: 60px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
